import { MatDialogRef } from '@angular/material';
var AlertComponent = (function () {
    function AlertComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.messageContent = AlertComponent.message;
        this.titleContent = AlertComponent.title;
    }
    AlertComponent.title = '';
    AlertComponent.message = '';
    return AlertComponent;
}());
export { AlertComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/alertComponent/alert.component.ts.pre-build-optimizer.js